
export default class Contactform {
    

    static get selector() {
      return '.contactForm';
    }
    
    constructor(el) {
        this.el = el;
        this.form = el.querySelector('.wpcf7-form');
        this.form.removeAttribute('novalidate');
        this.fields = this.getFields();
        this.updateFields();
        this.setEvents();
    }

    getFields() {
        let fields = [];
        let els = this.el.querySelectorAll('.field');
        els.forEach(element => {
            let field = {};
                field.el = element;
                field.input = element.querySelector('input, select, textarea');
                field.label = element.querySelector('label');
            fields.push(field);
        });
        return fields;
    }

    updateFields() {
        this.fields.forEach( field => {


            if(field.input.classList.contains('wpcf7-validates-as-required')){
                field.input.setAttribute('required', true);
            }

        });
    }

    setEvents() {
        this.fields.forEach( field => {
            field.input.addEventListener('focus', (e) => {
                console.log("focus");
            } )
            field.input.addEventListener('change', (e) => {
                console.log(field.input.value);
            } )
        });
    }
   

}